import Button from '@zenbusiness/zui/Button';
import Heading from '@zenbusiness/zui/Heading';
import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';

import useCardsContext from '#client/hooks/useCardsContext';

export default function GenerateCard() {
  const { handleCreateCard, isCreateCardLoading } = useCardsContext();

  const buttonText = isCreateCardLoading ? 'Generating...' : 'Generate';

  return (
    <Stack gap={{ xs: '32px', md: '40px' }}>
      <Heading
        family="secondary"
        size="2xl"
        weight="bold"
      >
        Virtual debit card details
      </Heading>
      <Stack gap="16px">
        <Text
          color="tertiary"
          size="xl"
        >
          Virtual card not generated
        </Text>
        <Button
          color="secondary"
          disabled={isCreateCardLoading}
          onClick={handleCreateCard}
          sx={{ width: 'max-content' }}
        >
          {buttonText}
        </Button>
      </Stack>
    </Stack>
  );
}
